import React from 'react';
import './styles.css';

export function GoogleG({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="#4285F4"
        d="M23.52 12.27c0-.82-.07-1.6-.21-2.36H12v4.48h6.47a5.53 5.53 0 0 1-2.4 3.63v3h3.88c2.27-2.09 3.57-5.17 3.57-8.75z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.08 7.95-2.91l-3.88-3c-1.08.72-2.45 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A12 12 0 0 0 12 24z"
      />
      <path
        fill="#FBBC05"
        d="M5.27 14.28a7.2 7.2 0 0 1 0-4.56V6.63H1.29a12 12 0 0 0 0 10.74l3.98-3.09z"
      />
      <path
        fill="#EA4335"
        d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.95 1.19 15.23 0 12 0A12 12 0 0 0 1.29 6.63l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"
      />
    </svg>
  );
}

export function AppleLogo({ size = 18, color = '#1A1A1A' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
      focusable="false"
    >
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 8.53 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.51 4.09l.02-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}

export const PAY_MODE_CARD = 'card';
export const PAY_MODE_GOOGLE_PAY = 'gpay';
export const PAY_MODE_APPLE_PAY = 'apay';

/**
 * Seletor "Como você quer pagar" dentro da aba Cartão do checkout.
 * Só renderiza quando existe pelo menos uma carteira disponível; o modo
 * "Cartão" é sempre a primeira opção.
 *
 * Fundo branco em todas as opções (o logo do Google Pay não pode ficar
 * sobre cor). A seleção é indicada de forma consistente por borda na cor
 * da loja e um tom suave de fundo, para todas as opções.
 */
export default function WalletPicker({
  value,
  onChange,
  googlePayAvailable = false,
  applePayAvailable = false,
  themeColor,
  themeIsWhite = false,
  disabled = false,
}) {
  if (!googlePayAvailable && !applePayAvailable) return null;

  const accent = themeColor || '#2544b1';
  const accentBorder = (themeIsWhite && '#000000') || accent;

  const activeStyle = {
    borderColor: accentBorder,
    boxShadow: `inset 0 0 0 1px ${accentBorder}`,
    backgroundColor: `color-mix(in srgb, ${accent} 7%, #fff)`,
  };

  const options = [
    {
      mode: PAY_MODE_CARD,
      label: 'Cartão',
      icon: <i className="las la-credit-card wallet-pick-icon" />,
      available: true,
    },
    {
      mode: PAY_MODE_GOOGLE_PAY,
      label: 'Google Pay',
      icon: <GoogleG />,
      available: googlePayAvailable,
    },
    {
      mode: PAY_MODE_APPLE_PAY,
      label: 'Apple Pay',
      icon: <AppleLogo />,
      available: applePayAvailable,
    },
  ].filter(opt => opt.available);

  return (
    <div className="wallet-picker">
      <div className="wallet-picker-label">Como você quer pagar</div>
      <div className="wallet-picker-options">
        {options.map(opt => {
          const active = value === opt.mode;
          return (
            <button
              key={opt.mode}
              type="button"
              className={`wallet-pick ${active ? 'wallet-pick-on' : ''}`}
              style={active ? activeStyle : undefined}
              aria-pressed={active}
              disabled={disabled}
              onClick={() => onChange(opt.mode)}
            >
              {opt.icon}
              <span>{opt.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

/**
 * Aviso exibido no modo carteira, acima do botão oficial.
 */
export function WalletNote({ walletLabel }) {
  return (
    <div className="wallet-note">
      <i className="las la-lock wallet-note-icon" />
      <span>
        Os dados do cartão vêm direto do {walletLabel}, sem digitar aqui. Os
        dados de cobrança são usados para a confirmação e a análise de segurança
        do pedido.
      </span>
    </div>
  );
}
